import { getCurrentDateTime } from "@/app/shared/utils/helpers";

export function downloadFile(
  data,
  fallbackFilename = "",
  { useResponseFileName = false, fileName = "" } = {}
) {
  let blob = useResponseFileName ? data?.data : data;

  if (typeof blob === "string") blob = new Blob([blob], { type: "text/plain" });

  const resposeFileName =
    fileName ||
    (
      data?.headers?.["content-disposition"]?.split("filename=")?.[1] ||
      `${getCurrentDateTime()}-${fallbackFilename}`
    ).replace(/^["']|["']$/g, "");

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", resposeFileName);
  document.body.appendChild(link);
  link.click();
}
